import { clearAnimationActions, ActionId } from 'owa-mail-list-item-animation-store';

import { invokeAnimationCallbacks } from './invokeAnimationCallbacks';
import { setAnimationAction } from 'owa-mail-list-item-animation-store/lib/actions/setAnimationAction';
import { getNextActionId } from './getNextActionId';

export function handleAnimationComplete(
    animationAction: ActionId | null,
    rows: Element[],
    animationRowIds: Set<string>
) {
    if (animationAction == 'PinInitial' || animationAction == 'UnpinInitial') {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.background = 'transparent';
            }
        });
        setAnimationAction(getNextActionId(animationAction), Array.from(animationRowIds));
    } else if (animationAction == 'PinMiddle' || animationAction == 'UnpinMiddle') {
        setAnimationAction(getNextActionId(animationAction), Array.from(animationRowIds));
    } else if (
        animationAction == 'PinFinal' ||
        animationAction == 'UnpinFinal' ||
        animationAction == 'AddRowFinal'
    ) {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.background = 'transparent';
            }
        });
        clearAnimationActions();
    } else if (animationAction == 'AddRowInitial') {
        setAnimationAction(getNextActionId(animationAction), Array.from(animationRowIds));
    } else {
        rows.forEach(row => {
            if (animationRowIds.has(row.id)) {
                (row as HTMLDivElement).style.opacity = '0';
            }
        });
        invokeAnimationCallbacks();
        clearAnimationActions();
    }
}
